export default "__VITE_ASSET__f3012296__"